import {io} from "socket.io-client";

let ws_scheme;

if (window.location.protocol === "https:") {
    ws_scheme = "wss://";
} else {
    ws_scheme = "ws://";
}


export const socket = io(ws_scheme + "deep-fake-detector-server.herokuapp.com", {
    reconnectionDelayMax: 10000,
});